import { IEventByDateItem } from '@entities/eventJournal';

export const useConditionalRendering = ({
    data,
    isFetched,
    isPlaceholderData,
    isFetching,
    isPending,
    isOnlyTwoParams,
    hasSortProp,
}: {
    data: IEventByDateItem[];
    isFetched: boolean;
    isPlaceholderData: boolean;
    isFetching: boolean;
    isPending: boolean;
    isOnlyTwoParams: boolean;
    hasSortProp: boolean;
}) => {
    const hasData = (data?.length ?? 0) > 0;

    const showSkeleton = !isFetched && (!isPlaceholderData || !hasData);

    const showList = hasData;

    const isStableEmpty = isFetched && !isPlaceholderData && !hasData && !isFetching && !isPending;

    const showInitialEmpty = isStableEmpty && isOnlyTwoParams && hasSortProp;
    const showFilteredNotFound = isStableEmpty && !isOnlyTwoParams;

    return {
        showSkeleton,
        showList,
        showInitialEmpty,
        showFilteredNotFound,
    };
};
